import { useTranslations } from '../context/TranslationContext';
import timiPicture from '../assets/timi.jpeg';

const NUMERALS = ['i.', 'ii.', 'iii.', 'iv.', 'v.', 'vi.'];

const AboutSection = () => {
  const { t } = useTranslations();

  return (
    <section id="about" className="py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-reveal>
          <div className="lg:col-span-4">
            <div className="eyebrow mb-4">03 / {t.about.title}</div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="display text-[42px] md:text-[56px]">{t.about.title}</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-4" data-reveal>
            <div className="overflow-hidden" style={{ aspectRatio: '4/5' }}>
              <img
                src={timiPicture}
                alt={t.hero.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-8 space-y-6 text-base leading-[1.9] text-ink font-light" data-reveal data-reveal-delay="100">
            {t.about.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
            <p className="display text-2xl md:text-[32px] text-accent italic mt-10 leading-[1.4]">
              {t.about.closing}
            </p>
          </div>
        </div>

        <div className="border-t border-hair mt-24 pt-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20" data-reveal>
            <div className="lg:col-span-4">
              <div className="eyebrow mb-4">{t.approach.title}</div>
            </div>
            <div className="lg:col-span-8">
              {/* Sub-section of About, so the heading sits a step below the
                  42/56px used by top-level section titles — same pattern,
                  subordinate rank. */}
              <h3 className="display text-[32px] md:text-[40px] mb-6">{t.approach.title}</h3>
              <p className="text-mute text-base leading-[1.8] max-w-2xl font-light">
                {t.approach.intro}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-16 gap-y-14">
            {t.approach.items.map((item, index) => (
              <div
                key={index}
                data-reveal
                data-reveal-delay={index % 2 === 1 ? '100' : undefined}
              >
                <div className="number-tag mb-3">{NUMERALS[index]}</div>
                <h4 className="text-lg font-medium mb-3 tracking-tight">{item.title}</h4>
                <p className="text-mute text-sm leading-[1.7] font-light">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
